export default __webpack_public_path__ + "images/2bb6efce5111105d0f777fd0fc107219.jpg";